import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import { CrearCotizacionComponent } from "./crear-cotizacion/crear-cotizacion.component";
import { CrearCotizacionDialog } from "./crear-cotizacion/crear-cotizacion-dialog/crear-cotizacion-dialog.component";
import { CopiarCotizacionComponent } from "./copiar-cotizacion/copiar-cotizacion.component";
import { CopiarCotizacionDialog } from "./copiar-cotizacion/copiar-cotizacion-dialog/copiar-cotizacion-dialog.component";
import { MaterialModule } from "../../components/material/material.module";
import { CotizacionComponent } from "./cotizacion/cotizacion.component";
import { ArchivoCotizacionModule } from "./archivos-cotizacion/archivo-cotizacion.module";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { PipesModule } from "../../pipes/pipes.module";
import { DetalleCotizacionComponent } from "./detalle-cotizacion/detalle-cotizacion.component";
import { EditarCotizacionComponent } from "./editar-cotizacion/editar-cotizacion.component";
import { EditarCotizacionDialog } from "./editar-cotizacion/editar-cotizacion-dialog/editar-cotizacion-dialog.component";
import { EliminarCotizacionComponent } from "./eliminar-cotizacion/eliminar-cotizacion.component";
import { EliminarCotizacionDialog } from "./eliminar-cotizacion/eliminar-cotizacion-dialog/eliminar-cotizacion-dialog.component";
import { EmailCotizacionDialog } from "./email-cotizacion-dialog/email-cotizacion-dialog.component";
import { ImprimirCotizacionComponent } from "./imprimir-cotizacion/imprimir-cotizacion.component";
import { VerCotizacionesComponent } from "./ver-cotizaciones/ver-cotizaciones.component";
import { ItemModule } from "./items/item.module";
import { RouterModule } from "@angular/router";
// import { CKEditorModule } from 'ng2-ckeditor';
import { IncidenciaModule } from "../incidencias/incidencia.module";
import { TipoCondicionService } from "../../providers/tipo-condicion.service";
import { TipoGarantiaService } from "../../providers/tipo-garantia.service";
import { CompetidorService } from "../../providers/competidor.service";
import { TipoPagoService } from "../../providers/tipo-pago.service";
import { TipoMonedaService } from "../../providers/tipo-moneda.service";
import { TipoImpuestoService } from "../../providers/tipo-impuesto.service";
import { TipoValidezService } from "../../providers/tipo-validez.service";
import { TipoEntregaService } from "../../providers/tipo-entrega.service";
import { ProductoService } from "../../providers/producto.service";
import { TipoPlazoService } from "../../providers/tipo-plazo.service";
import { CaracteristicaService } from "../../providers/caracteristica.service";
import { AutorizadorModule } from "../../components/autorizador/autorizador.module";
import { ComunicacionService } from "../../providers/comunicacion.service";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        MaterialModule,
        ArchivoCotizacionModule,
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        ItemModule,
        RouterModule,
        // CKEditorModule,
        IncidenciaModule,
        AutorizadorModule,
    ],
    declarations: [
        CopiarCotizacionComponent,
        CopiarCotizacionDialog,
        CotizacionComponent,
        CrearCotizacionComponent,
        CrearCotizacionDialog,
        DetalleCotizacionComponent,
        EditarCotizacionComponent,
        EditarCotizacionDialog,
        EliminarCotizacionComponent,
        EliminarCotizacionDialog,
        EmailCotizacionDialog,
        ImprimirCotizacionComponent,
        VerCotizacionesComponent,
    ],
    entryComponents: [
        CopiarCotizacionDialog,
        CrearCotizacionDialog,
        EditarCotizacionDialog,
        EliminarCotizacionDialog,
        EmailCotizacionDialog,
    ],
    exports: [
        CotizacionComponent,
        CopiarCotizacionComponent,
        CrearCotizacionComponent,
        DetalleCotizacionComponent,
        EditarCotizacionComponent,
        EliminarCotizacionComponent,
        ImprimirCotizacionComponent,
        VerCotizacionesComponent,
    ],
    providers: [
        TipoCondicionService,
        TipoGarantiaService,
        CompetidorService,
        TipoPagoService,
        TipoMonedaService,
        TipoImpuestoService,
        TipoValidezService,
        TipoEntregaService,
        ProductoService,
        TipoPlazoService,
        CaracteristicaService,
        ComunicacionService,
    ]
})
export class CotizacionModule { }
